import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import { ref, onMounted, reactive, onUpdated, onBeforeUnmount } from "vue";
import MenuStationMappingDataService from "@/services/MenuStationMappingDataService";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import { store } from "@/store/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("");
const alertState = ref("");
const menuTitle = ref("Menu-Station Mapping Maintenance");
const menuStationMappingList = reactive([]);
const modalTitle = ref("");
const buttonName = ref("");
const i18n = useI18n();
const isNoData = ref(false);

const selectedRowId = ref(0);
const deleteId = ref(0);

const selectedStation = ref("");
const selectedStationerror = ref("");
const stationList = reactive([]);
const selectedMainTitle = ref("");
const mainTitleList = reactive([]);
const selectedMenu = ref("");
const selectedMenuerror = ref("");
const oriMenuList = reactive([]);
const menuList = reactive([]);

function handleResize() {

  try {
    var tableHeight = 0;
    var dataHeight = 0;
    dataHeight = document.getElementById("tblMenuStationMappingBody")?.clientHeight ?? 0;
    if (dataHeight != 0) {
      tableHeight = document.getElementById("divMenuStationMappingTable")?.clientHeight ?? 0;
      if (dataHeight > tableHeight) {
        document.getElementById("divMenuStationMappingTable").style.width = "100%";
      } else {
        document.getElementById("divMenuStationMappingTable").style.width = "calc(100% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
}

const getMenuStationMappingList = () => {
  isLoading.value = true;
  menuStationMappingList.splice(0);
  
  MenuStationMappingDataService.getMenuStationMappingList().then((response: ResponseData) => {
    if (response.data.length != 0) {
      for (let info of response.data) {
        menuStationMappingList.push(info);
      }
      isLoading.value = false;
    }else {
      isNoData.value = true;
    }
  });

  isLoading.value = false;
};

const getStationCodeList = ()  => {    
    stationList.splice(0);
    stationList.push(store.getters.stationListData)
    selectedStation.value = stationList[0][0].stationCode;
};

const updateMenuListByTitle = (mainTitleCode: any) => {
  clearErrorMsg();
  selectedMainTitle.value = mainTitleCode;

  menuList.splice(0);
  if (oriMenuList.length > 0) {
      var lstMenuByTitle = oriMenuList[0].filter((obj: { mainTitleCode: { mainTitleCode: any; }; }) => obj.mainTitleCode.mainTitleCode == selectedMainTitle.value)
      if (lstMenuByTitle.length > 0){
              menuList.push(lstMenuByTitle);
              selectedMenu.value = menuList[0][0].mainMenuCode;
      }else{
        menuList.splice(0);
        selectedMenu.value = "";
      }
  }else {
    menuList.splice(0);
    selectedMenu.value = "";
  }
};

const getMenuByTitle = (event: { target: { value: any; }; }) => {
    updateMenuListByTitle(event.target.value);
}

const getMenuList = () => {
    oriMenuList.splice(0);
    menuList.splice(0);
    mainTitleList.splice(0);
    var data = {"targetScreen": "MenuStationMappingMaintenance"}
    MenuStationMappingDataService.getAllMainMenuInfo(data).then((resMenuList: ResponseData) => {
        mainTitleList.push(resMenuList.data.mainTitleList)
        selectedMainTitle.value = mainTitleList[0][0].mainTitleCode;
        oriMenuList.push(resMenuList.data.mainMenuList);
        if (oriMenuList.length > 0) {
            var lstMenuByTitle = oriMenuList[0].filter((obj: { mainTitleCode: { mainTitleCode: any; }; }) => obj.mainTitleCode.mainTitleCode == selectedMainTitle.value)            
            if (lstMenuByTitle.length > 0){
              menuList.push(lstMenuByTitle);
              selectedMenu.value = menuList[0][0].mainMenuCode;
            }else{
              menuList.splice(0);
              selectedMenu.value = "";
            }
        }else{
          menuList.splice(0);
          selectedMenu.value = "";
        }
        isLoading.value = false;
    })
    .catch((e: Error) => {
        console.log(e);
    });
};

onMounted(async () => {
  menuStationMappingList.splice(0);
  window.addEventListener('resize', handleResize);
  isLoading.value = true;
  await Promise.all([
    getMenuStationMappingList(),
    getMenuList(),
    getStationCodeList()    
  ]);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

onUpdated(() => {
  handleResize();
});

const onClickAddButton = () => {
  modalTitle.value = "Add Menu-Station Mapping";
  buttonName.value = "Add";

  clearErrorMsg();
  selectedStation.value = stationList[0][0].stationCode;
  updateMenuListByTitle(mainTitleList[0][0].mainTitleCode);
  selectedMenu.value = menuList[0][0].mainMenuCode;
};

const onClickEditButton = (id: any) => {
  modalTitle.value = "Edit Menu-Station Mapping";
  buttonName.value = "Update";
  
  clearErrorMsg();
  const data = { id: id };

  MenuStationMappingDataService.getRowMenuStationMapping(data)
    .then((response: ResponseData) => {
      if (response.data.length != 0) {
        for (let info of response.data) {
          updateMenuListByTitle(info.maintitlecode);          
          selectedMenu.value = info.mainmenucode;
          selectedStation.value = info.stationcode;
          selectedRowId.value = id;
        }
      } else {
        console.log("NO DATA");
      }
    })
    .catch((error: Error) => {
      console.log(error);
    });
};

const AddMenuStationMapping = () => {
  clearErrorMsg();

  const data = {
    id: 0,
    mainMenuCode: selectedMenu.value,
    stationCode: selectedStation.value,
    userId: store.getters.cognitoUserName
  };

  if(selectedMenu.value == ""){
    selectedMenuerror.value = i18n.t("alt117");
    return;
  }

  try{
    MenuStationMappingDataService.isExistMenuStationMapping(data)
      .then((response: ResponseData)=>{
        if (response.data.length == 1) {
          selectedStationerror.value = i18n.t("alt116");
          return;
        }
        else{
          isLoading.value = true;
          MenuStationMappingDataService.addMenuStationMapping(data)
            .then((response: ResponseData)=>{
              if(response.data.message == "success"){
                if (response.data.data.length != 0) {
                  menuStationMappingList.splice(0);
                  for (let info of response.data.data) {
                    menuStationMappingList.push(info);
                  }
              }

              alertMessage.value = i18n.t("suc048");
              alertState.value = "success";
              isLoading.value = false;
              }              
            })
            .catch((error: Error) => {
              console.log(error);
              alertMessage.value = i18n.t("err118");
              alertState.value = "error";
              isLoading.value = false;
            });
          document.getElementById("cancel")?.click();
        }
      }).catch((error: Error)=>{
        console.log(error);
        alertMessage.value = i18n.t("err118");
        alertState.value = "error";
        isLoading.value = false;
      }
    );
  }
  catch(error) {
    console.log(error);
    alertMessage.value = i18n.t("err118");
    alertState.value = "error";
    isLoading.value = false;
  }
};


const EditMenuStationMapping =async () => {
  clearErrorMsg();

  const data = {
    id: selectedRowId.value,
    mainMenuCode: selectedMenu.value,
    stationCode: selectedStation.value,
    userId: store.getters.cognitoUserName
  };

  if(selectedMenu.value == ""){
    selectedMenuerror.value = i18n.t("alt117");
    return;
  }

  try{
    MenuStationMappingDataService.isExistMenuStationMapping(data)
      .then((response: ResponseData)=>{
        if (response.data.length == 1 && response.data.id != data.id) {
          selectedStationerror.value = i18n.t("alt116");
          return;
        }
        else{
          isLoading.value = true;
          MenuStationMappingDataService.editMenuStationMapping(data)
            .then((response: ResponseData)=>{
              if(response.data.message == "success"){
                if (response.data.data.length != 0) {
                  menuStationMappingList.splice(0);
                  for (let info of response.data.data) {
                    menuStationMappingList.push(info);
                  }
              }

              alertMessage.value = i18n.t("suc049");
              alertState.value = "success";
              isLoading.value = false;
              }              
            })
            .catch((error: Error) => {
              console.log(error);
              alertMessage.value = i18n.t("err119");
              alertState.value = "error";
              isLoading.value = false;
            });
          document.getElementById("cancel")?.click();
        }
      }).catch((error: Error)=>{
        console.log(error);
        alertMessage.value = i18n.t("err119");
        alertState.value = "error";
        isLoading.value = false;
      }
    );
  }
  catch(error) {
    console.log(error);
    alertMessage.value = i18n.t("err119");
    alertState.value = "error";
    isLoading.value = false;
  }
};

const getDeleteId = (id: any) => {
  deleteId.value = id;
};

const DeleteMenuStationMapping = () => {
  document.getElementById("deleteCancel")?.click();
  alertMessage.value = "null";
  alertState.value = "neutral";

  isLoading.value = true;
  const data = { id: deleteId.value };
  MenuStationMappingDataService.deleteMenuStationMapping(data)
    .then((response: ResponseData)=>{
      if(response.data.message == "success"){
        if (response.data.data.length != 0) {
          menuStationMappingList.splice(0);
          for (let info of response.data.data) {
            menuStationMappingList.push(info);
          }
      }
      else{
        menuStationMappingList.splice(0);
      }
      alertMessage.value = i18n.t("suc047");
      alertState.value = "success";
      isLoading.value = false;
      }
    })
    .catch((error: Error) => {
      console.log(error);
      alertMessage.value = i18n.t("err120");
      alertState.value = "error";
      isLoading.value = false;
    });
};

const clearErrorMsg = () => {
  alertMessage.value = "null";
  alertState.value = "neutral";
  selectedMenuerror.value = "";
  selectedStationerror.value = "";
};


const __returned__ = { isLoading, alertMessage, alertState, menuTitle, menuStationMappingList, modalTitle, buttonName, i18n, isNoData, selectedRowId, deleteId, selectedStation, selectedStationerror, stationList, selectedMainTitle, mainTitleList, selectedMenu, selectedMenuerror, oriMenuList, menuList, handleResize, getMenuStationMappingList, getStationCodeList, updateMenuListByTitle, getMenuByTitle, getMenuList, onClickAddButton, onClickEditButton, AddMenuStationMapping, EditMenuStationMapping, getDeleteId, DeleteMenuStationMapping, clearErrorMsg, AdminNavigation, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})